import { FC, SVGProps } from 'react'

export const ClearIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM8.34548 15.6541C7.98424 15.2928 7.98424 14.7072 8.34548 14.3459L10.6916 11.9998L8.34593 9.65406C7.98469 9.29283 7.98469 8.70715 8.34593 8.34592C8.70716 7.98468 9.29284 7.98468 9.65408 8.34592L11.9998 10.6916L14.3455 8.34593C14.7067 7.98469 15.2924 7.98469 15.6536 8.34593C16.0149 8.70716 16.0149 9.29284 15.6536 9.65407L13.3079 11.9998L15.6541 14.3459C16.0153 14.7071 16.0153 15.2928 15.6541 15.6541C15.2928 16.0153 14.7072 16.0153 14.3459 15.6541L11.9998 13.3079L9.65363 15.6541C9.29239 16.0153 8.70672 16.0153 8.34548 15.6541Z"
        fill="#14151A"
      />
    </svg>
  )
}
